module.exports = __webpack_public_path__ + "media/images/check-9aeef4dd28f15be20e58e1c01a05b0b1.png";